import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { MetaApp } from '../types/meta.types';

interface DeleteAppDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    app: MetaApp | null;
    onConfirm: () => void;
    isLoading: boolean;
}

export default function DeleteAppDialog({
                                            open,
                                            onOpenChange,
                                            app,
                                            onConfirm,
                                            isLoading,
                                        }: DeleteAppDialogProps) {
    if (!app) return null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[450px]">
                <DialogHeader>
                    <div className="mx-auto w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
                        <AlertTriangle className="h-6 w-6 text-red-600" />
                    </div>
                    <DialogTitle className="text-2xl font-bold text-gray-900 text-center">
                        Excluir App?
                    </DialogTitle>
                    <DialogDescription className="text-gray-600 text-center">
                        Esta ação não pode ser desfeita. A app será desativada permanentemente.
                    </DialogDescription>
                </DialogHeader>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <div className="text-sm">
                        <span className="font-semibold text-gray-900">App:</span>{' '}
                        <span className="text-gray-700">{app.app_name}</span>
                    </div>
                    <div className="text-sm mt-1">
                        <span className="font-semibold text-gray-900">App ID:</span>{' '}
                        <span className="text-gray-700 font-mono">{app.app_id}</span>
                    </div>
                </div>

                <DialogFooter className="gap-2 sm:gap-0">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isLoading}
                        className="border-gray-300"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="bg-red-600 hover:bg-red-700 text-white"
                    >
                        {isLoading ? (
                            <>
                                <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                                Excluindo...
                            </>
                        ) : (
                            'Excluir App'
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}